var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"500","scrollable":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('Form',{attrs:{"order":_vm.order},on:{"done":function($event){_vm.dialog = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }